
import { mdiShieldCheckOutline } from '@mdi/js'
export default {
  props: {
    small: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mdiShieldCheckOutline,
      color: 'primary'
    }
  }
}
